export default "__VITE_ASSET__otopai7z__"